<template>
  <div >

    <!-- about view -->
    <router-view></router-view>


    <!-- single movie view -->
    <movie
      :filter="this.filterTags"
      :handleUpdateFilterTag="updateFilterTag"
      :preLoadingImage="this.preLoadingImage"
      class="">
    </movie>


    <!-- all movies view -->
    <div class="main-content">

      <!-- spinner -->
      <clip-loader :loading="isLoading" :color="color"></clip-loader>

      <!-- quote -->
      <div v-bind:class="['main-title', { 'main-title-menu-is-open' : this.$parent.isDisplayed }]" >

      <!--  <h1>Un homme sans culture ressemble à un zèbre sans rayures.</h1>
      <span>Proverbe africain</span> -->

        <!-- <h2>It doesn't get much bigger than that, right ?</h2>
        <span>Donald Trump (on bank regulation rollback)</span> -->
        <!--  <h2>Let's all watch as the world goes to the devil!</h2>
        <span>The Machine Man (Metropolis)</span> -->
        <h2>Well... the television said that's the right thing to do.</h2>
        <span>Tom, Night of the living dead</span>
      </div>

      <!-- featured movie -->
      <router-link v-if="onTop[0] && (onTop[0].backdrops || onTop[0].poster)" :to="{ name: 'movie', params: { slug: onTop[0].slug }}" v-bind:class="['on-top', { 'on-search' : filterKey || filterTags }]"  v-bind:style="{ backgroundImage: 'url(https://image.tmdb.org/t/p/w1280' + onTop[0].backdrops[0] + ')' }">

        <div>
          <div class="bloc-title">
            <h2>{{ onTop[0].title_tmdb }}</h2>
            <h3><span v-if="onTop[0].director">{{ onTop[0].director[0] }}, </span>{{ onTop[0].date }}</h3>
          </div>
          <div class="bloc-overview">
            <span v-if="onTop[0].overview">{{ onTop[0].overview }}</span>
            <span v-if="!onTop[0].overview && onTop[0].tagline">{{ onTop[0].overview.substring(0,65)+'...' }}</span>
            <span class="duration">{{ onTop[0].duration }} minutes</span>
          </div>
        </div>

      </router-link>



      <!-- movies -->
      <div class="movies">

        <transition-group name="populate" tag="div">

          <div v-for="(movie, i) in filteredMovies" v-bind:key="i" class="movie" @click="handleSelectMovie(movie)">

            <router-link v-if="movie && (movie.backdrops || movie.poster)" :to="{ name: 'movie', params: { slug: movie.slug }}">

                <div class="movie-image" v-bind:style="{ backgroundImage: 'url(https://image.tmdb.org/t/p/w780' + (movie.backdrops ? movie.backdrops[0] : movie.poster) + ')' }">

                  <div v-if="selectedMovie && selectedMovie.id_tmdb === movie.id_tmdb" class="movie-picto-is-playing">
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 58 58" style="enable-background:new 0 0 58 58;" xml:space="preserve">
                      <circle style="fill:rgba(44, 62, 80, 0.9);" cx="29" cy="29" r="29"/>
                      <polygon style="fill:rgb(255, 255, 255, 0.9)" points="44,29 22,44 22,29.273 22,14  "/>
                    </svg>
                  </div>

                  <div class="movie-infos">
                    <h2>
                      <div v-if="movie.slug">
                        {{ movie.title_tmdb }}
                      </div>
                      <div v-else>
                        <span>{{ movie.title_tmdb }}</span>
                      </div>
                    </h2>
                    <h3><span v-if="movie.director">{{ movie.director[0] }}, </span>{{ movie.date }}</h3>
                    <p class="synopsis">
                      <span v-if="movie.tagline">{{ movie.tagline }}</span>
                      <span v-if="!movie.tagline && movie.overview">{{ movie.overview.substring(0,65)+'...' }}</span>
                      <span class="duration">{{ movie.duration }} minutes</span>
                    </p>

                  </div>
                </div>
            </router-link>

            <div v-if="isDisplayed" class="movie-backdrops-admin" v-bind:style="{ background: (movie.backdrops ? 'url(https://image.tmdb.org/t/p/w300' + movie.backdrops[0] : 'blue') + ')' }">

              <span>{{movie.backdrops ? movie.backdrops.length : '0'}}</span>

              <img v-for="(backdrop, iBackdrop) in movie.backdrops" @click="selectImage(movie['.key'], movie.backdrops, backdrop, iBackdrop)" :src="'https://image.tmdb.org/t/p/w300' + backdrop" alt="">
            </div>

          </div>

        </transition-group>

      </div>

    <div :class="['no-results', {active: hasNoSearchResults}]">No results.</div>

    <!-- <div @click="loadLessMovies()" class="load-more active">Load less.</div> -->
    <!-- <div @click="loadMoreMovies()" :class="['load-more', {active: (isLoading===false && hasMoreToLoad)}]">Load more.</div> -->
    <!-- <div @click="getDataset()" :class="['load-more', {active: true}]">Load more.</div> -->

  </div>



  <!-- admin -->
  <div v-if="this.$route.name==='admin'" class="movies-ui-infos">
    INFOS :
    <br/>
      searchQuery : {{ filterKey }}
    <br/>
      Sort By : {{ sortKey }}
    <br/>
      Genre Selected : {{ filterTags }}
    <br>
      Movies Displayed : {{ loadedMoviesCount }}
    <br/>
    <span @click="toggleContent()">-! Admin backdrops !-</span>
  </div>


</template>

<script>

import Movie from './Movie'

import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import firebase from 'firebase'
import Vue from 'vue'
import vueSmoothScroll from 'vue-smoothscroll' // https://github.com/Teddy-Zhu/vue-smoothscroll
Vue.use(vueSmoothScroll, { name: 'smoothscroll' })

export default {

  name: 'Movies',

  components: {
    ClipLoader,
    Movie
  },

  props: {
    filterKey: String,
    sortKey: String,
    sortOrders: Object,
  },


  firebase() {


    var that = this;


    //Movies first set load
    var location = firebase.database().ref();
    var query = location.limitToFirst(100);
    query.once('value', function(snapshot) {
      that.isLoading = false; //to handle the spinner
      that.firebaseLazyLoad(); //Movies full db load
    }, function(error){
       //error
    });


    var dataMovieOntop = firebase
        .database()
        .ref()
        .orderByChild('slug')
        .equalTo('the-little-shop-of-horrors-(1960)')
        .limitToFirst(1);
    dataMovieOntop.on("value", function(snapshot) {
      var snap = snapshot.val();
      that.movieOnTop = snap;
    }, function (error) {
      console.log("Error: " + error.code);
    });

    return {
      data: query,
      onTop: dataMovieOntop,
    }
  },
  data: function () {

    var genre = this.$route.params.genre;
    var startLoadedMoviesCount = 9;
    var loadMoreMoviesCount = 3;


    //get first movies
    //this.getDataset();


    return {
      filterTags: genre ? genre : '',
      startLoadedMoviesCount: startLoadedMoviesCount,
      loadMoreMoviesCount: loadMoreMoviesCount,
      loadedMoviesCount: startLoadedMoviesCount,
      isDisplayed: false,
      hasMoreToLoad: true,
      hasNoSearchResults: false,
      isLoading: true,
      color: '#2c3e50',

      preLoadingImage: '',

      dataFb: [],
      start: '',
      n: 6,

      movieOnTop: {},

      selectedMovie: null,

    }
  },


  computed: {

    filteredMovies: function () {

      // console.log("in filteredMovies: ");

      var sortKey = this.sortKey && this.sortKey.toLowerCase()
      var order = - (this.sortOrders[sortKey] || 1)

      //var data = this.dataFb;
      var data = this.data;
      // console.log("data: ", data);

      var filterKey = this.filterKey && this.filterKey.toLowerCase().split(' ')
      if (filterKey) {
        data = data.filter(function (row) {
          return Object.keys(row).some(function (key) {

            var allKeywordsMatch = true;
            for (var i = 0; i < filterKey.length; i++) {
                if (String(row[key]).toLowerCase().indexOf(filterKey[i]) === -1) {
                    allKeywordsMatch = false;
                }
            }
            return allKeywordsMatch;

            //return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })

        if(data.length === 0){
          this.hasNoSearchResults = true;
        }else{
          this.hasNoSearchResults = false;
        }
      }else{
        this.hasNoSearchResults = false;
      }


      var filterTags = this.filterTags.toLowerCase()
      if(filterTags){
        data = data.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterTags) > -1
          })
        })
      }
      // to sort date or names for example
      if (sortKey) {
        data = data.slice().sort(function (a, b) {
          a = a[sortKey].replace(/^'/, ""); //we use replace() to get ride of first single quote in title sorting
          b = b[sortKey].replace(/^'/, "");
          return (a === b ? 0 : a > b ? 1 : -1) * order
        })
      }


      // for infinite load
      var loadedMoviesCount = this.loadedMoviesCount;
      var startLoadedMoviesCount = this.startLoadedMoviesCount;
      var total = data.length;
      if( (total > 0 && (total <= startLoadedMoviesCount || loadedMoviesCount >= total) )
        || (total === 0)
        ){
        this.hasMoreToLoad = false;
      }else{
        this.hasMoreToLoad = true;
      }
      data = data.slice(0,loadedMoviesCount)

      // console.log("dataEnd: ", data);
      return data
    }
  },

  mounted: function () {
    window.addEventListener('scroll', this.handleScrollInfiniteLoad);
  },
  beforeDestroy: function () {
    window.removeEventListener('scroll', this.handleScrollInfiniteLoad);
  },

  methods: {


    handleSelectMovie: function (movie){
      this.selectedMovie = movie;
      this.setPreLoadingImage(movie);
    },

    setPreLoadingImage: function (movie) {
      // console.log("movie: ", movie);
      this.preLoadingImage = movie.backdrops ? movie.backdrops[0] : movie.poster;
      // console.log("this.preLoadingImage: ", this.preLoadingImage);
    },

    firebaseLazyLoad: function () {
      var that = this;
      var query = firebase.database().ref();
      query.on('child_added', function(snapshot) {
        //////////////////////////////////////////////////////////////////////////////////////to do: add spinner if reach bottom before lazyload
        // console.log("LAZY LOAD IS OCCURING");
        if(snapshot.key > 99){
          that.data.push(snapshot.val());
        }
       }, function(error){
         //error
      });
    },

    selectImage: function (i, backdrops, backdrop, iBackdrop) {

      var movieSelect = firebase.database().ref(i+'/backdrops'),
          imageSelect = firebase.database().ref(i+'/backdrops/'+iBackdrop),
          oldFirst = backdrops[0];
      movieSelect.update({ 0:backdrop});
      imageSelect.update({ 0:oldFirst});

    },

    updateFilterTag: function (key) {
      //scroll to top
      this.$SmoothScroll(0, 300, function(){

        //reinit loaded movies count for the transition if new filter
        if(this.filterTags!==key){
          // this.filterKey='';
          this.loadedMoviesCount = 0;

          setTimeout(function(){
            //once transition is occuring, we display movies again
            this.loadedMoviesCount = this.startLoadedMoviesCount
          }.bind(this), 100);
        }

        if(key!==false){ // key is false if sort by title or date or search
          //store new filter tag
          this.filterTags = key
        }

      }.bind(this));
    },
    loadMoreMovies: function () {
      this.loadedMoviesCount += this.loadMoreMoviesCount
    },
    loadLessMovies: function () {
      this.loadedMoviesCount -= this.loadMoreMoviesCount
    },
    toggleContent: function() {

      this.isDisplayed = !this.isDisplayed
    },

    // getDataset: function() {

    //   // console.log("this.start: ", this.start);
    //   // console.log("this.end: ", this.end);
    //   // console.log("this.n: ", this.n);

    //   var that = this;


    //   var n = this.start === '' ? this.n : this.n + 1;
    //   var start = this.start === '' ? '0' : this.start;

    //   // console.log("pri: ", pri);

    //   this.isLoading = true;

    //   firebase
    //     .database()
    //     .ref()
    //     .orderByChild('slug')
    //     .startAt(start)
    //     .limitToFirst(n)
    //     .on("child_added", function(dataSnapshot) {
    //       if(that.start !== dataSnapshot.val().slug){
    //         that.dataFb.push(dataSnapshot.val());
    //         that.start = dataSnapshot.val().slug;
    //         that.isLoading = false;
    //       }


    //     }
    //   );
    // },

    handleScrollInfiniteLoad: function (event) {
      var margin = 200;
      if ((window.innerHeight + window.scrollY) >= document.body.scrollHeight - margin) {
        // you're at the bottom of the page
        // console.log("Bottom of page");
        this.loadMoreMovies();
        // this.getDataset();
      }

    }

  },

}


</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>


.about .main-content{
  display: none;
}

h1 {
  font-size: 13px;

}

.movie{
  transition: transform 0.1s;
}
.populate-enter-active{
  transform: scale(0.2);
}
.populate-leave-active {
  transform: scale(0.2);
}
.populate-enter {
}
.populate-leave-to {
}


.main-title {
  display: block;
  width: 730px;
  margin: auto;
  margin-bottom: 50px;
  margin-top: 20px;
  transition: all 0.2s ease;

  padding-top: 0px;
  padding-bottom: 20px;

  &.main-title-menu-is-open{
    padding-top: 20px;
    padding-bottom: 0;
  }

  h2 {
    color: #000;
    font-size: 31px;
    font-weight: 100;
    font-style: italic;
    margin: 0;
  }
  span {
    font-size: 12px;
    color: #000;
  }

}
.on-top {
  position: relative;
  display: block;
  width: 1060px;
  height: 250px;
  margin: auto;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center 29%;
  &.on-search {
    display: none;
  }
  .bloc-title {
    z-index: 10;
    position: absolute;
    top: -0;
    left: -0;
    padding: 15px;
    background: rgba(44, 62, 80, 0.7);
    color: #fff;
    h2 {
      font-size: 19px;
      color: white;
      text-transform: uppercase;
      font-weight: 600;
      margin: 0;
    }
    h3 {
      font-size: 13px;
      color: white;
      text-transform: uppercase;
      font-weight: 200;
      margin: 0;
    }
  }
  .bloc-overview {
    position: absolute;
    top: 62%;
    left: 15px;
    transform: translateY(-50%);
    z-index: 9;
    background-color: rgba(0, 0, 0, 0.6);
    width: 300px;
    color: #fff;
    padding: 15px;
    font-weight: 12px;
    transition: all .35s ease;
    opacity: 0;

    .duration{
      display: block;
      margin-top: 6px;
      font-weight: bold;
    }
  }

}
.movies {
  display: block;
  width: 1060px;
  margin: auto;
  transition: all .35s ease;

  h2 {
    font-size: 19px;
    color: white;
    text-transform: uppercase;
    font-weight: 600;
    margin: 0;
  }
  h3 {
    font-size: 13px;
    color: white;
    text-transform: uppercase;
    font-weight: 200;
    margin: 0;
  }
  .movie {
    position: relative;
    background: url(../assets/tarot_sun.svg) no-repeat 50% 50%;
    display: inline-block;
    vertical-align: top;
    width: 350px;
    height: 250px;
    margin: 5px 5px 0 0;
    &:nth-child(3n) {
      margin-right: 0;
    }
    .synopsis {
      // height: 100px;
      position: absolute;
      bottom: 0;
      width: calc(100% - 40px);
      opacity: 0;
      padding: 20px 0px;
      margin: 0;
      color:  #fff;
      transition: opacity 0.2s ease;

      .duration{
        display: block;
        margin-top: 6px;
        font-weight: bold;
      }
    }


    .movie-infos {
      box-sizing: border-box;
      padding : 20px;
      height: 100%;
      width: 100%;
      transition: background 0.2s ease;

      background-color: transparent;
      // background-image: linear-gradient(to bottom,rgba(0,0,0,0.4),transparent 35%);
      background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.7), transparent 50%);

      a {
        text-decoration: none;
        color: #fff;
      }
    }

    .movie-image {
      display: inline-block;
      height: 250px;
      width: 100%;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
    }
    .movie-picto-is-playing{
      width: 80px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

  }
}

.movie.active .movie-backdrop{
  display: inline-block;
}


.movies-ui span:hover{
  text-decoration: underline;
  cursor: pointer;
}

.movies-ui-infos{
  position: fixed;
  bottom: 0;
  right: 0;
}

.movie-backdrop{
  width: 200px;
  display: inline-block;
}
.movie-backdrop img{
  width: 100%
}


.v-spinner{
  position: absolute!important;
  z-index: 100;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.no-results{
  display: none;
  text-align: center;
  padding-top: 30px;
  font-size: 26px;
}
.no-results.active{
  display: block;
}

.load-more{
  cursor: pointer;
  display: none;
}
.load-more.active{
  display: block;
}
.load-more:hover{
  text-decoration: underline;
}


.slide-enter-active {
  transition: all .35s ease;
}
.slide-leave-active {
  transition: all .35s ease;
}
.slide-enter, .slide-leave-active {
  transform: translateX(50%);
}

.warning-date-green{
  background: green;
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
.warning-date-red{
  background: red;
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
}



/* ADMIN */

.movie-backdrops-admin{
  width: 90px;
  height: 50px;
  transform: translateY(-52px);
  float: right;
  background-size: cover !important;
  background: blue;
  border: 1px solid red;

  span{
    color: red;
    font-size: 22px;
    display: inline-block;
    padding: 1px 3px;
    border-left: 1px solid red;
    border-top: 1px solid red;
    background-color: black;
    position: absolute;
    right: 0;
    bottom: 0;
  }
  img{
    width: 260px;
    display: none;
  }

  &:hover{
    position: fixed;
    right: 20px;
    width: 80%;
    top: 0;
    background: blue!important;
    height: 90%;
    z-index: 9999;
    transform: translateY(0px);
    overflow-y: scroll;
    border: none;

    span{
      display: none;
    }

    img{
      display: inline-block;
      border: 1px solid transparent;
      cursor: n-resize;
      &:hover{
        border: 1px solid red;
        transform: scale(2) translateY(22px);
      }
    }
  }
  .testdebug{
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 9999;
    background: red;
  }

}
.no-touchevents {
  .on-top {
    &:hover {
      .bloc-overview {
        opacity: 1;
      }
    }
  }
  .movies {
    .movie {
      &:hover {
        .movie-image {
        }
        .movie-infos {
          background-image: radial-gradient(rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.7))
          //background-color: rgba(0, 0, 0, 0.6);
        }
        .synopsis {

          opacity: 1;
        }
      }
    }
  }
}
/* /RESPONSIVE */
@media screen and (max-width: 1224px) {
  .main-title {
    width: 580px;
    h2 {
      font-size: 25px;
    }
    span {
      font-size: 12px;
    }


  }
  .on-top {
    width: 705px;
  }
  .movies {
    width: 705px;
    .movie {
      &:nth-child(3n) {
        margin: 5px 5px 0 0;
      }
      &:nth-child(2n) {
        margin-right: 0;
      }
    }
  }
}

@media screen and (max-width: 768px) {

  .on-top {
    width: 100%;
    .bloc-title {
      width: auto;
    }
    .bloc-overview {
      display: none;
      left: 0;
      width: 100%;
      opacity: 1;
    }
  }
  .movies {
    width: 100%;
    .movie {
      position: relative;
      display: block;
      width: 100%;
      margin-right: 0px;
      .movie-infos {
        position:absolute;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.6);
        width: auto;
        height: auto;
        .synopsis {
          display: none;
          opacity: 1;
          height: auto;
        }
      }



    }
  }
}

@media screen and (max-width: 640px) {
  .main-title {
    width: 270px;
    h2 {
      font-size: 22px;
    }
    span {
      font-size: 10px;
    }


  }

}

</style>



// WEBPACK FOOTER //
// Movies.vue?80dfdd30